var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "prod_settings" },
    [
      _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_weight" } },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.__t("PRODUCT_UNIQ_ID")) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-group flex-nowrap" }, [
            _c("div", { staticClass: "input-group-prepend" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
              ]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.product.uniq_id,
                  expression: "product.uniq_id",
                },
              ],
              staticClass: "form-control",
              attrs: { id: "advanced_weight", type: "text" },
              domProps: { value: _vm.product.uniq_id },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.product, "uniq_id", $event.target.value)
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "providers" }, [
          _c("h5", { staticClass: "frame-heading mt-4" }, [
            _vm._v(_vm._s(_vm.__t("PUBLISHED_TTL_PROV"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "frame-wrap2" },
            _vm._l(_vm.providers_services, function (prov) {
              return _c(
                "div",
                {
                  key: prov.id,
                  staticClass:
                    "custom-control custom-checkbox custom-control-inli",
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: prov.is_on,
                        expression: "prov.is_on",
                      },
                    ],
                    staticClass: "custom-control-input",
                    attrs: { type: "checkbox", id: prov.type },
                    domProps: {
                      checked: Array.isArray(prov.is_on)
                        ? _vm._i(prov.is_on, null) > -1
                        : prov.is_on,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = prov.is_on,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(prov, "is_on", $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                prov,
                                "is_on",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(prov, "is_on", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: prov.type },
                    },
                    [_vm._v(_vm._s(prov.human_name))]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "skeep_sync mt-5" }, [
          _c("h5", { staticClass: "frame-heading" }, [
            _vm._v(_vm._s(_vm.__t("SKEEP_TTL"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "custom-control custom-checkbox custom-control-inline",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.product.skeep_sync,
                    expression: "product.skeep_sync",
                  },
                ],
                staticClass: "custom-control-input",
                attrs: { type: "checkbox", id: "skeep_sync" },
                domProps: {
                  checked: Array.isArray(_vm.product.skeep_sync)
                    ? _vm._i(_vm.product.skeep_sync, null) > -1
                    : _vm.product.skeep_sync,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.product.skeep_sync,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(_vm.product, "skeep_sync", $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.product,
                            "skeep_sync",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.product, "skeep_sync", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  attrs: { for: "skeep_sync" },
                },
                [_vm._v(_vm._s(_vm.__t("SKEEP_SYNC")))]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.product.is_alco
          ? _c("div", { staticClass: "form-group mt-5" }, [
              _c(
                "label",
                {
                  staticClass: "form-label",
                  attrs: { for: "advanced_weight" },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.__t("ALCO_PERCENT")) +
                      "\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-group flex-nowrap" }, [
                _c("div", { staticClass: "input-group-prepend" }, [
                  _c("span", { staticClass: "input-group-text" }, [
                    _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
                  ]),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.product.alco_percent,
                      expression: "product.alco_percent",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "advanced_weight",
                    type: "number",
                    min: "0",
                    max: "100",
                  },
                  domProps: { value: _vm.product.alco_percent },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.product, "alco_percent", $event.target.value)
                    },
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-4" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_name" } },
            [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(_vm.__t("PRODUCT_RENAME")) +
                  "\n\t\t\t\t"
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-group flex-nowrap" }, [
            _c("div", { staticClass: "input-group-prepend" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
              ]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.product.adv_name,
                  expression: "product.adv_name",
                },
              ],
              staticClass: "form-control",
              attrs: { id: "advanced_name", type: "text" },
              domProps: { value: _vm.product.adv_name },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.product, "adv_name", $event.target.value)
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_weight" } },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.__t("PRODUCT_WEIGHT")) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-group flex-nowrap" }, [
            _c("div", { staticClass: "input-group-prepend" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
              ]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.product.weight,
                  expression: "product.weight",
                },
              ],
              staticClass: "form-control",
              attrs: { id: "advanced_weight", type: "text" },
              domProps: { value: _vm.product.weight },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.product, "weight", $event.target.value)
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_weight" } },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.__t("PRODUCT_TAX")) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-group flex-nowrap" }, [
            _c("div", { staticClass: "input-group-prepend" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
              ]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.product.tax,
                  expression: "product.tax",
                },
              ],
              staticClass: "form-control",
              attrs: {
                id: "advanced_weight",
                type: "number",
                min: "0",
                max: "100",
              },
              domProps: { value: _vm.product.tax },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.product, "tax", $event.target.value)
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "intro_html" } },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.__t("INTRO_PROD_HTML")) +
                  "\n\n                    "
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-xs btn-dark waves-effect waves-themed",
                  attrs: { type: "button" },
                  on: { click: _vm.make_ai_suggest },
                },
                [_vm._v("Generate AI")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-group flex-nowrap d-block" },
            [
              _c("div", { staticClass: "input-group-prepend" }, [
                _c("span", { staticClass: "input-group-text" }, [
                  _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-overlay",
                { attrs: { show: _vm.is_ai_work } },
                [
                  _c("vue-editor", {
                    attrs: { "editor-toolbar": _vm.editor_rules },
                    model: {
                      value: _vm.product.introcontent,
                      callback: function ($$v) {
                        _vm.$set(_vm.product, "introcontent", $$v)
                      },
                      expression: "product.introcontent",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_name" } },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.__t("MIN_QUAL")) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-group flex-nowrap" }, [
            _c("div", { staticClass: "input-group-prepend" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
              ]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.product.buy_min_qual,
                  expression: "product.buy_min_qual",
                },
              ],
              staticClass: "form-control",
              attrs: { id: "min_qual", type: "number", min: "0", max: "100" },
              domProps: { value: _vm.product.buy_min_qual },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.product, "buy_min_qual", $event.target.value)
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "advanced_name" } },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.__t("PRODUCT_ORDERING")) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-group flex-nowrap" }, [
            _c("div", { staticClass: "input-group-prepend" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
              ]),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.product.ordering,
                  expression: "product.ordering",
                },
              ],
              staticClass: "form-control",
              attrs: { id: "ctg_ordering", type: "number" },
              domProps: { value: _vm.product.ordering },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.product, "ordering", $event.target.value)
                },
              },
            }),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }